import { dropdownCommonTheme } from './common-theme';
export const dropdownLightTheme = dropdownCommonTheme;
//# sourceMappingURL=light-theme.js.map